// Browser stand-in for node:os. platform() deliberately returns "web" so
// win32/darwin-specific code paths fuse off.
module.exports = {
    EOL: "\n",
    platform: () => "web",
    type: () => "Web",
    release: () => "0.0.0",
    version: () => "0.0.0",
    arch: () => "web",
    cpus: () => [],
    totalmem: () => 0,
    freemem: () => 0,
    uptime: () => 0,
    loadavg: () => [0, 0, 0],
    hostname: () => "browser",
    homedir: () => "/home/web",
    tmpdir: () => "/tmp",
    endianness: () => "LE",
    networkInterfaces: () => ({}),
    userInfo: () => ({
        username: "web",
        homedir: "/home/web",
        shell: null,
        uid: -1,
        gid: -1,
    }),
};
